module.exports = __webpack_public_path__ + "8b18e6af0beffaa3bc629243b5febc2a.ttf";